'use client'
import { createElement, useEffect, useState } from 'react';

const TermlyScriptWrapper = ({ dataId }) => {
  const [mounted, setMounted] = useState(false);

  // Wait for component to mount to avoid hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script if component unmounts
      const existingScript = document.querySelector('script[src="https://app.termly.io/embed-policy.min.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  if (!dataId || !mounted) {
    return null;
  }

  return createElement('div', {
    name: 'termly-embed',
    'data-id': dataId,
    'data-type': 'iframe'
  });
};

export default TermlyScriptWrapper;

